export function Input({ className = "", ...props }) {
  return (
    <input
      className={[
        "w-full rounded-xl border px-3 py-2 transition",
        "bg-dulia-parchmentSoft text-dulia-ink border-dulia-line",
        "placeholder:text-dulia-navy/45",
        "focus:outline-none focus:ring-2 focus:ring-dulia-gold/35 focus:border-dulia-lineStrong",
        "dark:bg-dulia-nightSoft dark:text-dulia-parchment dark:border-dulia-lineStrong/30",
        "dark:placeholder:text-dulia-parchment/40",
        "dark:focus:ring-dulia-gold/30 dark:focus:border-dulia-gold/60",
        "disabled:cursor-not-allowed disabled:opacity-50",
        className,
      ].join(" ")}
      {...props}
    />
  );
}

export default Input;